import { useGet } from "./hooks";
const BioURL = "https://stetor16.dreamhosters.com/wp-json/acf/v3/bio";

function BioItems() {
  const [data, loading] = useGet(BioURL);

  return (
    <>
      <div className="bio__data-container ">
        {loading ? (
          "Loading..."
        ) : (
          <>
            {data.map((d, index) => {
              return (
                <div key={index} className="bio__profile-box ">
                  <h1 className="bio__profile-name site__heading  text-center pb-3">
                    {d.acf.bio_name}
                  </h1>
                  <div className="bio__img-bio text-center">
                    <img
                      className="bio__profile-img"
                      src={d.acf.bio_image}
                      alt="user-portrait"
                    />

                    <p className="bio__profile-desc site__paragraph">
                      {d.acf.bio_desc}
                    </p>
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>
    </>
  );
}
export default BioItems;
